import type { AdminSession } from '../../types/api'

const STORAGE_KEY = 'nns_admin_v2_session'
export const SESSION_CHANGED_EVENT = 'nns-admin-session-changed'

export function readSession(): AdminSession | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)
    if (!value) return null
    const parsed = JSON.parse(value) as Partial<AdminSession>
    return parsed.accessToken && parsed.refreshToken
      ? { accessToken: parsed.accessToken, refreshToken: parsed.refreshToken }
      : null
  } catch {
    return null
  }
}

export function writeSession(session: AdminSession) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session))
  window.dispatchEvent(new Event(SESSION_CHANGED_EVENT))
}

export function clearSession() {
  sessionStorage.removeItem(STORAGE_KEY)
  window.dispatchEvent(new Event(SESSION_CHANGED_EVENT))
}
